export const capitalEachLetter = (str) => {
    let newName =
      str &&
      str
        .split(" ")
        .map((ele) => ele[0]?.toUpperCase() + ele.slice(1))
        .join(" ");
    return newName;
  };